<form #thisForm="ngForm" (ngSubmit)="submit()">
  <app-dados-boleta
    titulo="Dados da Boleta - Empréstimo"
    [operationDate]="model.operationDate"
    [id]="model.id"
    [accountManagerName]="model.accountManagerName"
    [accountManagerDocument]="model.accountManagerDocument"
    [statusDescription]="model.statusDescription"
  >
  </app-dados-boleta>

  <div class="card">
    <div class="card-header text-uppercase">Tipo de Boleta</div>
    <div class="card-body">
      <div class="col-12" [class.has-error]="hasError('typeAction')">
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            name="typeAction"
            [(ngModel)]="model.typeAction"
            type="radio"
            id="typeAction-1"
            data-cy="typeAction"
            [value]="1"
          />
          <label class="form-check-label" for="typeAction-1"
            >Nova Operação</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            name="typeAction"
            [(ngModel)]="model.typeAction"
            type="radio"
            id="typeAction-2"
            data-cy="typeAction"
            [value]="2"
          />
          <label class="form-check-label" for="typeAction-2"
            >Liquidação Antecipada</label
          >
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            name="typeAction"
            [(ngModel)]="model.typeAction"
            type="radio"
            id="typeAction-3"
            data-cy="typeAction"
            [value]="3"
          />
          <label class="form-check-label" for="typeAction-3">Renovação</label>
        </div>
      </div>
    </div>
  </div>
  <app-dados-fundo
    #portfolio
    [canEdit]="canEdit()"
    [canValidate]="canValidate"
    [ticketType]="TicketTypeEnum.Loan"
  ></app-dados-fundo>

  <div class="card mt-3">
    <div class="card-header text-uppercase">Dados da Operação</div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-6">
          <label>Corretora</label>
          <input
            type="text"
            class="form-control"
            name="broker"
            [(ngModel)]="model.broker"
            data-cy="broker"
            required
          />
        </div>
        <div class="col-6">
          <label>Agente de Compensação</label>
          <input
            type="text"
            class="form-control"
            name="clearingAgent"
            [(ngModel)]="model.clearingAgent"
            data-cy="clearingAgent"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-3" [class.has-error]="hasError('loanType')">
          <label for="loanType-1">Natureza de operação</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="loanType"
                [(ngModel)]="model.loanType"
                data-cy="loanType"
                id="loanType-1"
                value="Tomador"
              />
              <label class="form-check-label" for="loanType-1">Tomador</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="loanType"
                [(ngModel)]="model.loanType"
                data-cy="loanType"
                id="loanType-2"
                data-cy="sale"
                value="Doador"
              />
              <label class="form-check-label" for="loanType-2">Doador</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label for="isReversibleByDonor">Reversível pelo doador?</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                name="isReversibleByDonor"
                [(ngModel)]="model.isReversibleByDonor"
                data-cy="isReversibleByDonor"
                id="isReversibleByDonor"
              />
            </div>
          </div>
        </div>
        <div class="col-4">
          <label>Data de Vencimento</label>
          <input
            #dueDate
            type="text"
            class="form-control"
            name="dueDate"
            [(ngModel)]="model.dueDate"
            data-cy="dueDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            required
          />
        </div>
        <div class="col-4">
          <label>Número de Contrato</label>
          <input
            type="text"
            class="form-control"
            name="contractNumber"
            [(ngModel)]="model.contractNumber"
            data-cy="contractNumber"
            [required]="isSettlementRenewal()"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-6">
          <label>Código do Papel</label>
          <input
            type="text"
            class="form-control"
            name="paperCode"
            [(ngModel)]="model.paperCode"
            data-cy="paperCode"
            required
          />
        </div>
        <div class="col-6">
          <label>Quantidade de Ações</label>
          <input
            type="text"
            class="form-control"
            name="stocksAmount"
            [(ngModel)]="model.stocksAmount"
            data-cy="stocksAmount"
            required
            [textMask]="{ mask: validator.decimalStocksAmountMask }"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-4">
          <label>Data Final de Carência</label>
          <input
            type="text"
            class="form-control"
            data-cy="finalGraceDate"
            name="papefinalGraceDaterCode"
            [(ngModel)]="model.finalGraceDate"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            [required]="isNewOperationRenewal()"
          />
        </div>
        <div class="col-4">
          <label>Taxa de Remuneração</label>
          <input
            type="text"
            class="form-control"
            data-cy="remunerationRate"
            name="paperCremunerationRateode"
            [(ngModel)]="model.remunerationRate"
            [required]="isNewOperationRenewal()"
            [textMask]="{ mask: validator.decimalRemunerationRateMask }"
          />
        </div>
        <div class="col-4">
          <label>Taxa de Comissão</label>
          <input
            type="text"
            class="form-control"
            data-cy="commissionFee"
            name="commissionFee"
            [(ngModel)]="model.commissionFee"
            [textMask]="{ mask: validator.decimalCommissionFeeMask }"
          />
        </div>
      </div>

      <div class="row mb-2">
        <div
          class="col-4"
          [class.has-error]="hasError('settlementPeriodicity')"
        >
          <label>Periodicidade de Liquidação</label>
          <mat-select
            class="form-control"
            data-cy="settlementPeriodicity"
            name="settlementPeriodicity"
            [(ngModel)]="model.settlementPeriodicity"
          >
            <mat-option>Nenhum</mat-option>
            <mat-option [value]="1">Dias corridos</mat-option>
            <mat-option [value]="2">Dias Úteis</mat-option>
            <mat-option [value]="3">Mensal</mat-option>
            <mat-option [value]="4">Semestral</mat-option>
            <mat-option [value]="5">Anual</mat-option>
          </mat-select>
        </div>
        <div class="col-4" [class.has-error]="hasError('loanOperationTypeId')">
          <label>Tipo de Operação</label>
          <mat-select
            class="form-control"
            data-cy="loanOperationTypeId"
            name="loanOperationTypeId"
            [(ngModel)]="model.loanOperationTypeId"
          >
            <mat-option [value]="1" *ngIf="model.loanType === 'Doador'"
              >Doador Renovável</mat-option
            >
            <mat-option [value]="2" *ngIf="model.loanType === 'Tomador'"
              >Tomador Renovável</mat-option
            >
            <mat-option [value]="3" *ngIf="model.loanType === 'Tomador'"
              >Tomador não Renovável</mat-option
            >
            <mat-option [value]="4" *ngIf="model.loanType === 'Doador'"
              >Doador não Renovável</mat-option
            >
          </mat-select>
        </div>
        <div class="col-4">
          <label>Código de Operação</label>
          <input
            type="text"
            class="form-control"
            data-cy="operationCode"
            name="operationCode"
            [(ngModel)]="model.operationCode"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4">
          <label for="marginCredit">Crédito de Margem</label>
          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                data-cy="marginCredit"
                id="marginCredit"
                name="marginCredit"
                [(ngModel)]="model.marginCredit"
              />
            </div>
          </div>
        </div>
        <div
          class="col-4"
          [class.has-error]="hasError('priceSettlementReference')"
        >
          <label for="priceSettlementReference-1"
            >Cotação Liquidação Preço Referência</label
          >
          <div>
            <div class="form-check form-check-inline">
              <input
                type="radio"
                class="form-check-input"
                data-cy="priceSettlementReference"
                id="priceSettlementReference-1"
                [value]="1"
                name="priceSettlementReference"
                [(ngModel)]="model.priceSettlementReference"
              />
              <label class="form-check-label" for="priceSettlementReference-1"
                >Início</label
              >
            </div>
            <div class="form-check form-check-inline">
              <input
                type="radio"
                class="form-check-input"
                data-cy="priceSettlementReference"
                id="priceSettlementReference-2"
                [value]="2"
                name="priceSettlementReference"
                [(ngModel)]="model.priceSettlementReference"
              />
              <label class="form-check-label" for="priceSettlementReference-2"
                >Vencimento</label
              >
            </div>
          </div>
        </div>
      </div>

      <br />
      <app-annotation
        #annotation
        [annotation]="model.annotations"
      ></app-annotation>

      <div class="actions" *ngIf="canEdit()">
        <input
          type="button"
          data-cy="submit"
          value="Salvar"
          class="btn btn-primary me-2"
          [disabled]="!canEdit()"
          appDebounceClick
          (debounceClick)="submit()"
          [debounceTime]="200"
        />
        <input
          type="button"
          data-cy="forward"
          value="Encaminhar"
          class="btn btn-primary me-2"
          [disabled]="!canEdit()"
          appDebounceClick
          (debounceClick)="forward()"
          [debounceTime]="200"
        />
        <input
          type="button"
          value="Cancelar"
          class="btn btn-danger me-2"
          [disabled]="!canCancel()"
          appDebounceClick
          (debounceClick)="cancel()"
          [debounceTime]="200"
        />
      </div>

      <div class="actions" *ngIf="canChangeStatus()">
        <input
          type="button"
          data-cy="approve"
          value="Aprovar"
          class="btn btn-success me-2"
          appDebounceClick
          (debounceClick)="approve()"
          [debounceTime]="200"
        />
        <input
          type="button"
          data-cy="reject"
          value="Reprovar"
          class="btn btn-danger me-2"
          appDebounceClick
          (debounceClick)="reject()"
          [debounceTime]="200"
        />
      </div>

      <div class="actions" *ngIf="canDuplicate()">
        <input
          type="button"
          data-cy="duplicate"
          value="Duplicar"
          class="btn btn-primary me-2"
          [disabled]="!model.id"
          appDebounceClick
          (debounceClick)="duplicate()"
          [debounceTime]="200"
        />
      </div>
    </div>
  </div>
</form>

<app-workflow-history
  [ticketId]="model.id"
  [refresh]="dataChanged"
></app-workflow-history>
